import React from 'react';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import TierIcon16 from '@wix/da-ds/pkg/Icons/16x16/Tier';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import TierConsumerReduxModule from '../../../../../../Tier/redux/consumer/ModuleLoadable';
import { usePrimaryTier } from '../../../../../../Tier/PrimaryTierContext';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../../../../TierProductCardDumb/utils';
import { useSubscribeButton } from '../../../../../../Button/SubscribeButton/useSubscribeButton';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
const NeedsSubscriptionMiddleContent = ({ deviation, thumbHeight, thumbWidth, className })=>{
    var _tier_tier, _tier_tier1;
    const tier = usePrimaryTier(deviation);
    const { onClick, href, biData, text } = useSubscribeButton(tier);
    const { t } = useTranslation();
    const isDsUpdate = useFlag('ds_update_btn_medium');
    if (!tier) {
        return null;
    }
    const canShowDescription = thumbWidth && thumbWidth > 250 ? thumbHeight && thumbHeight > 200 : thumbHeight && thumbHeight > 230;
    const canShowCTA = thumbWidth && thumbWidth > 250 ? thumbHeight && thumbHeight > 150 : thumbHeight && thumbHeight > 200;
    const isUnreasonablySmall = thumbHeight && thumbHeight < 150;
    if (isUnreasonablySmall) {
        return /*#__PURE__*/ React.createElement(HoverOnly, {
            reverseHidden: true
        }, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
            icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
                type: "in-tier",
                size: "large"
            }),
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
        icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            type: "in-tier",
            size: "small"
        }),
        subtitle: canShowDescription ? t('deviationview.overlay.subscriber.perMonth', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            dollarPrice: formatPrice((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.dollarPrice),
            price: /*#__PURE__*/ React.createElement("span", null, formatPrice((_tier_tier1 = tier.tier) === null || _tier_tier1 === void 0 ? void 0 : _tier_tier1.dollarPrice))
        }) : undefined,
        buttonHref: href,
        buttonTitle: canShowCTA ? text : undefined,
        buttonStyle: "solid",
        buttonIcon: isDsUpdate ? TierIcon16 : TierIcon,
        onButtonClick: onClick,
        biData: biData,
        className: className
    }), /*#__PURE__*/ React.createElement(TierConsumerReduxModule, null));
};
NeedsSubscriptionMiddleContent.displayName = 'NeedsSubscriptionMiddleContent';
export default NeedsSubscriptionMiddleContent;

//# sourceMappingURL=NeedsSubscriptionMiddleContent.js.map